import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector) // détecte la langue du navigateur
  .use(initReactI18next)
  .init({
    fallbackLng: "en", // langue par défaut
    debug: true, // tu peux le désactiver en prod
    interpolation: {
      escapeValue: false // React gère déjà la sécurité XSS
    },
    resources: {
      en: {
        translation: require("../assets/i18n/en.json")
      },
      fr: {
        translation: require("../assets/i18n/fr.json")
      }
    }
  });

export default i18n;
